import Footer from "../components/Footer";
import { Helmet } from "react-helmet";
export default function MediaReleases() {
  return (
    <>
      <Helmet>
        <title>Media | Public Speaking Academy</title>
        <meta
          name="description"
          content="Public Speaking training, Led by Darren Tay, coaches you effective communication and presentation skills in group. Contact us at 6443 4049 today!"
        ></meta>
      </Helmet>

      <section id="breadcrumb" className="bg-[#F5F5FC] py-1">
        <div className="container mx-auto">
          <div className="flex justify-between mx-2">
            <div>Media Releases</div>
            <div>Home / About / Media Releases</div>
          </div>
        </div>
      </section>

      <section id="mission-vision-top">
        <div className="mt-10 rounded-3xl">
          <div className="container mx-auto">
            <div className="pt-14">
              <div className="flex flex-col space-y-10 lg:space-y-0 lg:space-x-10 lg:flex-row">
                <div className="w-full">
                  <div className="p-5 mx-3 border border-gray-400 border-dashed rounded-2xl">
                    <div className="">
                      <h2 className="py-4 text-3xl font-bold uppercase text-primary font-primary">
                        CHANNEL NEWS ASIA TV SERIES FEATURE
                      </h2>
                      <iframe
                        src="https://www.youtube.com/embed/4cHGL4tcUek"
                        frameborder="0"
                        allowfullscreen
                        className="w-full rounded-lg aspect-video"
                      ></iframe>
                    </div>
                    <p className="py-4 text-xl font-text text-textColor">
                      In this Channel News Asia video, our founder, 2016
                      Toastmasters World Champion of Public Speaking Darren Tay
                      gets featured on CNA Insider's new TV series as an expert
                      on the art of persuasion and communication skills. In this
                      episode of the series, Darren joins the show’s host, Jason
                      Lai, on a journey to find out how neuroscience,
                      storytelling, psychology are key to swaying minds.
                    </p>
                    <div className="py-4">
                      <a
                        href="https://www.channelnewsasia.com/watch/nudge/nudges-sway-minds-4012081"
                        className="px-8 py-2 text-xl font-bold text-white rounded-md bg-btnColor"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        READ MORE
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <!-- Mission Vision Section --> */}
      <section id="mission-vision-1">
        <div className="mx-3 mt-10 lg:mx-20 rounded-3xl">
          <div className="container mx-auto">
            <div className="pt-14">
              <div className="flex flex-col space-y-10 lg:space-y-0 lg:space-x-10 lg:flex-row">
                <div className="w-full">
                  <div className="p-5 border border-gray-400 border-dashed rounded-2xl">
                    <div className="">
                      <h2 className="py-4 text-3xl font-bold uppercase text-primary font-primary">
                        Yahoo Finance
                      </h2>
                      <img
                        className="m-auto rounded-lg"
                        src="images/image of 2016 world champion of public speaking darren tay delivering presentation on stage.png"
                        alt=""
                      />
                    </div>
                    <p className="py-4 text-xl font-text text-textColor">
                      (Darren Tay, the 2016 Toastmasters International world
                      champion of public speaking, during his winning speech,
                      “Outsmart; Outlast.”Toastmasters International)
                    </p>
                    <p className="py-4 text-xl font-text text-textColor">
                      Darren Tay, a 27-year-old Singaporean lawyer, became the
                      2016 Toastmasters International world champion of public
                      speaking in August, surviving several rounds of a
                      competition that lasted six months and included more than
                      30,000 competitors from Toastmasters’ public speaking
                      clubs around the world...
                    </p>
                    <div className="py-4">
                      <a
                        href="https://finance.yahoo.com/news/2016-world-champion-public-speaking-203156551.html?guccounter=1"
                        className="px-8 py-2 text-xl font-bold text-white rounded-md bg-btnColor"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        READ MORE
                      </a>
                    </div>
                  </div>
                </div>
                <div className="w-full">
                  <div className="p-5 border border-gray-400 border-dashed rounded-2xl">
                    <div className="">
                      <h2 className="py-4 text-3xl font-bold uppercase text-primary font-primary">
                        Business Insider
                      </h2>
                      <img
                        className="m-auto rounded-lg"
                        src="images/image of 2016 world champion of public speaking darren tay delivering presentation.png"
                        alt=""
                      />
                    </div>
                    <p className="py-4 text-xl font-text text-textColor">
                      On Saturday, August 20, 27-year-old Singaporean lawyer
                      Darren Tay became the Toastmasters International world
                      champion of public speaking. He survived several rounds of
                      a competition that lasted six months and included more
                      than 30,000 competitors from Toastmasters public speaking
                      clubs around the world.
                    </p>
                    <p className="py-4 text-xl font-text text-textColor">
                      He and nine other finalists competed at the Toastmasters
                      annual convention, held this year at Marriott Marquis in
                      Washington, D.C. Tay took home first place for his...
                    </p>
                    <div className="py-4">
                      <a
                        href="https://www.businessinsider.com/toastmasters-public-speaking-champion-darren-tay-2016-8"
                        className="px-8 py-2 text-xl font-bold text-white rounded-md bg-btnColor"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        READ MORE
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="pb-10"></div>
        </div>
      </section>

      <section id="mission-vision-2">
        <div className="mt-20 rounded-3xl bg-[#f5f5f5]">
          <div className="container mx-auto">
            <div className="pt-14">
              <div className="flex flex-col space-y-10 lg:space-y-0 lg:space-x-10 lg:flex-row">
                <div className="w-full">
                  <div className="p-5 mx-3 border border-gray-400 border-dashed rounded-2xl">
                    <div className="">
                      <h2 className="py-4 text-3xl font-bold uppercase text-primary font-primary">
                        Straits Times
                      </h2>
                      <img
                        className="m-auto rounded-lg"
                        src="images/image of 2016 world champion of public speaking darren tay delivering speech on stage.png"
                        alt=""
                      />
                    </div>
                    <p className="py-4 text-xl font-text text-textColor">
                      (Darren Tay, the 2016 Toastmasters International world
                      champion of public speaking, during his winning speech,
                      “Outsmart; Outlast.”Toastmasters International).
                    </p>
                    <p className="py-4 text-xl font-text text-textColor">
                      Darren Tay, a 27-year-old Singaporean lawyer, became the
                      2016 Toastmasters International world champion of public
                      speaking in August, surviving several rounds of a
                      competition that lasted six months and included more than
                      30,000 competitors from Toastmasters’ public speaking
                      clubs around the world...
                    </p>
                    <div className="py-4">
                      <a
                        href="https://www.straitstimes.com/singapore/singaporean-lawyer-wins-international-public-speaking-championship"
                        className="px-8 py-2 text-xl font-bold text-white rounded-md bg-btnColor"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        READ MORE
                      </a>
                    </div>
                  </div>
                </div>
                <div className="w-full">
                  <div className="p-5 mx-2 border border-gray-400 border-dashed rounded-2xl">
                    <div className="">
                      <h2 className="py-4 text-3xl font-bold uppercase text-primary font-primary">
                        BBC World News
                      </h2>
                      <img
                        className="m-auto rounded-lg"
                        src="images/image of 2016 world champion of public speaking darren tay presenting to a crowd.png"
                        alt=""
                      />
                    </div>
                    <p className="py-4 text-xl font-text text-textColor">
                      BBC World News Interviews Toastmasters World Champion of
                      Public Speaking Darren Tay
                    </p>

                    <div className="py-4">
                      <a
                        href="https://www.youtube.com/watch?v=zpnQqjkd6Ps"
                        className="px-8 py-2 text-xl font-bold text-white rounded-md bg-btnColor"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        READ MORE
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="pb-20"></div>
        </div>
      </section>

      <section id="mission-vision-3">
        <div className="mx-3 mt-10 rounded-3xl">
          <div className="container mx-auto">
            <div className="pt-14">
              <div className="flex flex-col space-y-10 lg:space-y-0 lg:space-x-10 lg:flex-row">
                <div className="w-full lg:w-1/2">
                  <div className="p-5 border border-gray-400 border-dashed rounded-2xl">
                    <div className="">
                      <h2 className="py-4 text-3xl font-bold uppercase text-primary font-primary">
                        CNA News Interview
                      </h2>
                      <img
                        className="m-auto rounded-lg"
                        src="images/image of 2016 world champion of public speaking darren tay's speech on stage.png"
                        alt=""
                      />
                    </div>
                    <p className="py-4 text-xl font-text text-textColor">
                      In this video, World Champion of Public Speaking, Darren
                      Tay talks about the speech that he gave in a white
                      underwear.
                    </p>
                    <div className="py-4">
                      <a
                        href="https://www.youtube.com/watch?v=g5NS-YFHEaQ"
                        className="px-8 py-2 text-xl font-bold text-white rounded-md bg-btnColor"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        READ MORE
                      </a>
                    </div>
                  </div>
                </div>
                <div className="w-full lg:w-1/2">
                  <div className="p-5 border border-gray-400 border-dashed rounded-2xl">
                    <div className="">
                      <h2 className="py-4 text-3xl font-bold uppercase text-primary font-primary">
                        TOASTMASTERS INTERNATIONAL
                      </h2>
                      <img
                        className="m-auto rounded-lg"
                        src="images/image of 2016 world champion of public speaking speaking on stage.png"
                        alt=""
                      />
                    </div>
                    <p className="py-4 text-xl font-text text-textColor">
                      "RANCHO SANTA MARGARITA, Calif., Aug. 22, 2016
                      /PRNewswire/ -- With a humorous speech titled "Outsmart;
                      Outlast," Darren Tay, a 27-year-old newly minted lawyer
                      from Singapore, won the Toastmasters World Championship of
                      Public Speaking on Saturday, Aug. 20. Tay, along with nine
                      other finalists, reached the championship level after
                      several elimination rounds that began six months ago with
                      30,000 participants from more than 100 countries."
                    </p>

                    <div className="py-4">
                      <a
                        href="https://mediacenter.toastmasters.org/2016-08-22-Lawyer-from-Singapore-wins-Toastmasters-2016-World-Championship-of-Public-Speaking"
                        className="px-8 py-2 text-xl font-bold text-white rounded-md bg-btnColor"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        READ MORE
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="mx-3 mt-10 rounded-3xl">
          <div className="container mx-auto">
            <div className="pt-14">
              <div className="flex flex-col space-y-10 lg:space-y-0 lg:space-x-10 lg:flex-row">
                <div className="w-full lg:w-1/2">
                  <div className="p-5 border border-gray-400 border-dashed rounded-2xl">
                    <div className="">
                      <h2 className="py-4 text-3xl font-bold uppercase text-primary font-primary">
                        GOALCAST
                      </h2>
                      <img
                        className="m-auto rounded-lg"
                        src="images/goalcast-psa.webp"
                        alt=""
                      />
                    </div>
                    <p className="py-4 text-xl font-text text-textColor">
                      Darren Tay tells of his childhood experiences being
                      bullied and what he did to overcome it.
                    </p>
                    <div className="py-4">
                      <a
                        href="https://www.goalcast.com/darren-tay-why-is-he-wearing-his-underwear-on-the-outside-of-his-pants/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="px-8 py-2 text-xl font-bold text-white rounded-md bg-btnColor"
                      >
                        READ MORE
                      </a>
                    </div>
                  </div>
                </div>
                <div className="w-full lg:w-1/2">
                  <div className="p-5 border border-gray-400 border-dashed rounded-2xl">
                    <div className="">
                      <h2 className="py-4 text-3xl font-bold uppercase text-primary font-primary">
                        ARAB TIMES
                      </h2>
                      <img
                        className="m-auto rounded-lg"
                        src="images/arab-times.jpg"
                        alt=""
                      />
                    </div>
                    <p className="py-4 text-xl font-text text-textColor">
                      9 Dec 2016 — Darren Tay will address the audience for the
                      first time in Kuwait and the GCC at the Australian College
                      of Kuwait at 2.30 pm. Arab Times
                    </p>

                    <div className="py-4">
                      <a
                        href="https://www.pressreader.com/kuwait/arab-times/20161209/282484298390494?srsltid=AfmBOoqmNr-qXhhRaL8zI2B-5p_7XsOdGHAmr0vC713i_RxM73DJ3UNu"
                        className="px-8 py-2 text-xl font-bold text-white rounded-md bg-btnColor"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        READ MORE
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="mission-vision-4">
        <div className="mt-20 rounded-3xl bg-[#f5f5f5]">
          <div className="container mx-auto">
            <div className="pt-14">
              <div className="flex flex-col space-y-10 lg:space-y-0 lg:space-x-10 lg:flex-row">
                <div className="w-full">
                  <div className="p-5 mx-3 border border-gray-400 border-dashed rounded-2xl">
                    <div className="">
                      <h2 className="py-4 text-3xl font-bold uppercase text-primary font-primary">
                        CNN NEWS
                      </h2>
                      <iframe
                        src="https://www.youtube.com/embed/C1fqbmY5iCc"
                        frameborder="0"
                        allowfullscreen
                        className="w-full rounded-lg aspect-video"
                      ></iframe>
                    </div>
                    <p className="py-2 text-xl font-text text-textColor">
                      “ARE YOU READY TO WITNESS THE BEST? THE BEST OF THE BEST?”
                      a caption flashing across a jumbo screen asks the
                      audience. The crowd roars approval. “LET THE CONTEST
                      BEGIN!”
                    </p>
                    <p className="py-2 text-xl font-text text-textColor">
                      It’s the finale of the 2016 World Championship of Public
                      Speaking, but it feels more like fight night in Vegas. Ten
                      finalists warm up backstage like boxers psyching
                      themselves up for the ring. Some bop their heads and
                      shimmy to dance music on their headphones. Others
                      pantomime dramatic hand gestures while rehearsing their
                      lines out loud.
                    </p>
                    <p className="py-2 text-xl font-text text-textColor">
                      They’ve come halfway around the globe to get on a stage
                      and do something most people find frightening. They’re the
                      renegades in an increasingly mute society where people
                      prefer to text and tweet than actually talk to one
                      another. They’ve emerged from a field of 30,000
                      contestants from countries as far away as Australia, South
                      Korea and Zimbabwe. Their seven-minute speeches draw
                      laughter and gasps of surprise. They reduce the audience
                      to silence with heart-tugging confessions.
                    </p>
                    <div className="py-4">
                      <a
                        href="https://edition.cnn.com/2016/10/14/us/toastmasters-champions/index.html"
                        className="px-8 py-2 text-xl font-bold text-white rounded-md bg-btnColor"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        READ MORE
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="pb-20"></div>
        </div>
      </section>

      <section>
        <div className="mt-20">
          <div className="container mx-auto">
            <div className="pt-14">
              <div className="flex flex-col space-y-10 lg:space-y-0 lg:space-x-10 lg:flex-row">
                <div className="w-full">
                  <div className="p-5 mx-3 border border-gray-400 border-dashed rounded-2xl">
                    <div className="">
                      <h2 className="py-4 text-3xl font-bold uppercase text-primary font-primary">
                        NEXTSHARK
                      </h2>
                      <img
                        className="m-auto rounded-lg"
                        src="images/arab-times.jpg"
                        alt="Nextshark"
                      />
                    </div>
                    <p className="py-2 text-xl font-text text-textColor">
                      Darren Tay, a 27-year-old Singaporean lawyer, emerged as
                      Toastmasters International’s World Champion of Public
                      Speaking for 2016, beating nine other orators at the event
                      held in Washington, DC on Saturday.
                    </p>

                    <div className="py-4">
                      <a
                        href="https://nextshark.com/darren-tay-toastmasters-world-champion"
                        className="px-8 py-2 text-xl font-bold text-white rounded-md bg-btnColor"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        READ MORE
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="pb-20"></div>
        </div>
      </section>

      <Footer />
    </>
  );
}
